(function () {
    'use strict';

    angular.module('swif.patrimoine')
    .factory('swifPatrimoineControlTypeService', swifPatrimoineControlTypeService)
    .directive('panelPatrimoineControlType', panelPatrimoineControlType);


    /**
        * @ngdoc service
        * @name swif.patrimoine.swifPatrimoineControlTypeService
        * @requires swif.framework.swifFrameworkService
    **/
    function swifPatrimoineControlTypeService(swif) {
        'ngInject';
        var service = {};
        service.swif = swif;
        service.getCollection = function () {
            return swif.collections.getCollection('control_types');
        };
        service.createCollection = function () {
            var filter = {};
            swif.data.sortOn(filter, 'id', 'DESC');
            return swif.collections.createOrUpdate(
                'control_types',
                'patrimoine_control_type',
                filter,
                {location: true}
            );
        };
        service.callback = function (error, data) {
            return service.getCollection().defaultActionCallback(error, data);

        };
        service.preValidate = function () {
            return true;
        };
        return service;
    }



    function panelPatrimoineControlType(swif) {
        'ngInject';
        var directive = swif.panel.create_directive('patrimoine_control_type');
        directive.templateUrl = 'partials/patrimoine/panel-control-type.html';
        return directive;
    }

})();
